/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignPlanAssetsRequestDto,
  AssignPlanAssetsResponseDto,
  ListAssignableAssetsResponseDto,
  ListAssignmentConflictsResponseDto,
  ListPlanAssetsResponseDto,
  PreviewAssignmentConflictsRequestDto,
} from '../models/index';
import {
    AssignPlanAssetsRequestDtoFromJSON,
    AssignPlanAssetsRequestDtoToJSON,
    AssignPlanAssetsResponseDtoFromJSON,
    AssignPlanAssetsResponseDtoToJSON,
    ListAssignableAssetsResponseDtoFromJSON,
    ListAssignableAssetsResponseDtoToJSON,
    ListAssignmentConflictsResponseDtoFromJSON,
    ListAssignmentConflictsResponseDtoToJSON,
    ListPlanAssetsResponseDtoFromJSON,
    ListPlanAssetsResponseDtoToJSON,
    PreviewAssignmentConflictsRequestDtoFromJSON,
    PreviewAssignmentConflictsRequestDtoToJSON,
} from '../models/index';

export interface PlanAssetControllerAssignRequest {
    planId: string;
    assignPlanAssetsRequestDto: AssignPlanAssetsRequestDto;
}

export interface PlanAssetControllerFindActiveRequest {
    planId: string;
}

export interface PlanAssetControllerFindAssignableRequest {
    planId: string;
}

export interface PlanAssetControllerPreviewConflictsRequest {
    planId: string;
    previewAssignmentConflictsRequestDto: PreviewAssignmentConflictsRequestDto;
}

/**
 * 
 */
export class PreventiveMaintenancePlanAssetsApi extends runtime.BaseAPI {

    /**
     */
    async planAssetControllerAssignRaw(requestParameters: PlanAssetControllerAssignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssignPlanAssetsResponseDto>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling planAssetControllerAssign().'
            );
        }

        if (requestParameters['assignPlanAssetsRequestDto'] == null) {
            throw new runtime.RequiredError(
                'assignPlanAssetsRequestDto',
                'Required parameter "assignPlanAssetsRequestDto" was null or undefined when calling planAssetControllerAssign().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans/{planId}/assets`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignPlanAssetsRequestDtoToJSON(requestParameters['assignPlanAssetsRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssignPlanAssetsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planAssetControllerAssign(requestParameters: PlanAssetControllerAssignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssignPlanAssetsResponseDto> {
        const response = await this.planAssetControllerAssignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async planAssetControllerFindActiveRaw(requestParameters: PlanAssetControllerFindActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPlanAssetsResponseDto>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling planAssetControllerFindActive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans/{planId}/assets`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListPlanAssetsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planAssetControllerFindActive(requestParameters: PlanAssetControllerFindActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPlanAssetsResponseDto> {
        const response = await this.planAssetControllerFindActiveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async planAssetControllerFindAssignableRaw(requestParameters: PlanAssetControllerFindAssignableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAssignableAssetsResponseDto>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling planAssetControllerFindAssignable().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans/{planId}/assets/assignable`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAssignableAssetsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planAssetControllerFindAssignable(requestParameters: PlanAssetControllerFindAssignableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAssignableAssetsResponseDto> {
        const response = await this.planAssetControllerFindAssignableRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async planAssetControllerPreviewConflictsRaw(requestParameters: PlanAssetControllerPreviewConflictsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAssignmentConflictsResponseDto>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling planAssetControllerPreviewConflicts().'
            );
        }

        if (requestParameters['previewAssignmentConflictsRequestDto'] == null) {
            throw new runtime.RequiredError(
                'previewAssignmentConflictsRequestDto',
                'Required parameter "previewAssignmentConflictsRequestDto" was null or undefined when calling planAssetControllerPreviewConflicts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans/{planId}/assets/preview-conflicts`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PreviewAssignmentConflictsRequestDtoToJSON(requestParameters['previewAssignmentConflictsRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAssignmentConflictsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planAssetControllerPreviewConflicts(requestParameters: PlanAssetControllerPreviewConflictsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAssignmentConflictsResponseDto> {
        const response = await this.planAssetControllerPreviewConflictsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
